// extracted by mini-css-extract-plugin
export default {"download_button":"DownloadButton_download_button__tlu44","download_button_container":"DownloadButton_download_button_container__S8X0P"};